function Roadmap() {
  return (
    <section id="Roadmap">
      <h2>Roadmap</h2>
      <p>
        This app demonstrates that the inner workings of an LLM can be reconstructed using
        interpretable circuits; however, the app currently extracts graphs from very small LLMs. For
        it to become useful beyond educational or academic purposes, we need to (i) scale up the
        model being analyzed and (ii) enable real-time analysis of LLM responses.
      </p>
      <p>
        For now, our immediate goals are to stick with models using the GPT-2 architecture and
        reattempt our analysis using larger configurations. In a future iteration of this app, we
        hope to use a model with more layers and wider embeddings.
      </p>
    </section>
  );
}

export { Roadmap };
